const queryString = require('query-string');

export const SearchURLGenerator = (filtersObject) => queryString.stringify({ ...filtersObject }, { arrayFormat: 'comma' });

export {
  buildSearchResultsUrl,
  buildGeoLandingUrl,
  buildAgentSearchResultsUrl,
  GEO_SEARCH_LANDING_SLUGS,
} from './searchResultsUrl';




